import { Button, Checkbox, Col, Divider, Modal, Row, Spin } from "antd";
import RideComponentRecent from "../../components/RideComponents/RideComponentRecent";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BOOKING, FARE, RATES, RUSH } from "../../config/constants/api";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { Get } from "../../config/api/get";
import swal from "sweetalert";
import { Post } from "../../config/api/post";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

const RecentPage = () => {
  const navigate = useNavigate();
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [hoveredLocation, setHoveredLocation] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [distance, setDistance] = useState(null);
  const [selectedTiming, setSelectedTiming] = useState("0-0");
  const [notificationData, setNotificationData] = useState(null);
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const data = location?.state?.data;
  const [servicesRates, setServicesRates] = useState(null);
  const [latestFares, setLatestFares] = useState(null);
  const [latestRates, setLatestRates] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [isMember, setIsMember] = useState(true);
  const [notes, setNotes] = useState("");
  const [totalRushHours, setTotalRushHours] = useState(0);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (!data) {
      navigate(-1);
    } else {
      getServicesRates();
      getAllLatestFares();
      getAllLatestRates();
      if (data?.duration) {
        getTotalRushHours();
      }
    }
  }, []);
  const onChange = (e) => {
    setChecked(e.target.checked);
  };
  const getAllLatestFares = async () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
          setPricing(response?.data?.pricing);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getAllLatestRates = async () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getPerMileRate = () => {
    if (latestFares) {
      if (selectedTiming.split("-")[0] === "0") {
        let black = latestFares.find(
          (fare) =>
            fare._id.serviceType === "Black" &&
            fare._id.passengerCapacity ===
              parseInt(
                Object.keys(servicesRates?.Black)[selectedTiming.split("-")[1]]
              )
        );
        return black.fare;
      } else if (selectedTiming.split("-")[0] === "1") {
        let ultra = latestFares.find(
          (fare) =>
            fare._id.serviceType === "Ultra" &&
            fare._id.passengerCapacity ===
              parseInt(
                Object.keys(servicesRates?.Ultra)[selectedTiming.split("-")[1]]
              )
        );
        return ultra.fare;
      } else if (selectedTiming.split("-")[0] === "2") {
        let suv = latestFares.find(
          (fare) =>
            fare._id.serviceType === "Suv" &&
            fare._id.passengerCapacity ===
              parseInt(
                Object.keys(servicesRates?.Suv)[selectedTiming.split("-")[1]]
              )
        );
        return suv.fare;
      }
      else if (selectedTiming.split("-")[0] === "3") {
        let ultraBeyond = latestFares.find(
          (fare) =>
            fare._id.serviceType === "Ultra Beyond" &&
            fare._id.passengerCapacity ===
              parseInt(
                Object.keys(servicesRates["Ultra Beyond"])[selectedTiming.split("-")[1]]
              )
        );
        return ultraBeyond.fare;
      }
    }
  };

  const getHourlyRate = () => {
    if (latestRates) {
      if (selectedTiming.split("-")[0] === "0") {
        let black = latestRates.find(
          (rate) =>
            rate._id.serviceType === "Black" &&
            parseInt(rate._id.passengerCapacity) ===
              parseInt(
                Object.keys(servicesRates?.Black)[selectedTiming.split("-")[1]]
              )
        );

        return black.rate;
      } else if (selectedTiming.split("-")[0] === "1") {
        let ultra = latestRates.find(
          (rate) =>
            rate._id.serviceType === "Ultra" &&
            parseInt(rate._id.passengerCapacity) ===
              parseInt(
                Object.keys(servicesRates?.Ultra)[selectedTiming.split("-")[1]]
              )
        );
        return ultra.rate;
      } else if (selectedTiming.split("-")[0] === "2") {
        let suv = latestRates.find(
          (rate) =>
            rate._id.serviceType === "Suv" &&
            parseInt(rate._id.passengerCapacity) ===
              parseInt(
                Object.keys(servicesRates?.Suv)[selectedTiming.split("-")[1]]
              )
        );
        return suv.rate;
      } 
      else if (selectedTiming.split("-")[0] === "3") {
        let ultraBeyond = latestRates.find(
          (rate) =>
            rate._id.serviceType === "Ultra Beyond" &&
            parseInt(rate._id.passengerCapacity) ===
              parseInt(
                Object.keys(servicesRates["Ultra Beyond"])[selectedTiming.split("-")[1]]
              )
        );
        return ultraBeyond.rate;
      }
    }
  };
  // const getHourlyRate = () => {
  //   if (latestRates) {
  //     console.log(latestRates, "latestRates");

  //     if (selectedTiming.split("-")[0] === '0') {
  //       let black = latestRates.find((rate) => rate._id.serviceType === "Black");
  //       return black?.rate;
  //     } else if (selectedTiming.split("-")[0] === '1') {
  //       let ultra = latestRates.find((rate) => rate._id === "Ultra");
  //       return ultra?.rate;
  //     } else if (selectedTiming.split("-")[0] === '2') {
  //       let suv = latestRates.find((rate) => rate._id === "Suv");
  //       return suv?.rate;
  //     }
  //   }
  // };

  // const getTotalFare = () => {
  //   let total = 0;
  //   if (data?.initialMileage) {
  //     total += data?.initialMileage.toFixed(2) * getPerMileRate();
  //   }
  //   if (!isMember) {
  //     total += data?.duration * getHourlyRate();
  //   }
  //   return total.toFixed(2);
  // };
  const handleProceed = async () => {
    let postData = {
      customerName: userData?.firstName
        ? userData?.firstName + " " + userData?.lastName
        : "-",
      date: data?.date,
      time: data?.time,
      duration: data?.duration || 0,
      // serviceType:
      //   selectedTiming === 1 ? "Black" : selectedTiming === 2 ? "Ultra" : "SUV",
      type: data?.type,
      pickupLocation: data?.pickupLocation,
      initialMileage: data?.type === "PtoP" ? data?.initialMileage : null,
      dropoffLocation: data?.type === "PtoP" ? data?.dropoffLocation : null,
      notes: notes ? notes : null,
    };
    switch (selectedTiming.split("-")[0]) {
      case "0":
        postData["serviceType"] = "Black";
        postData["passengerCapacity"] = parseInt(
          Object.keys(servicesRates?.Black)[selectedTiming.split("-")[1]]
        );
        break;
      case "1":
        postData["serviceType"] = "Ultra";
        postData["passengerCapacity"] = parseInt(
          Object.keys(servicesRates?.Ultra)[selectedTiming.split("-")[1]]
        );
        break;
      case "2":
        postData["serviceType"] = "Suv";
        postData["passengerCapacity"] = parseInt(
          Object.keys(servicesRates?.Suv)[selectedTiming.split("-")[1]]
        );
        break;
      case "3":
        postData["serviceType"] = "Ultra Beyond";
        postData["passengerCapacity"] = parseInt(
          Object.keys(servicesRates['Ultra Beyond'])[selectedTiming.split("-")[1]]
        );
        break;
    }
    Post(BOOKING.bookChauffeur, postData, token)
      .then((response) => {
        if (response?.status) {
          swal(
            "Success",
            "Your Booking is Pending. Kindly Make Payment to confirm your booking",
            "success"
          );
        }
        navigate("/payment", {
          state: {
            type: "Booking",
            total: getToPay().toFixed(2),
            // total:
            //   selectedTiming === 1
            //     ? servicesRates?.black
            //     : selectedTiming === 2
            //     ? servicesRates?.ultra
            //     : servicesRates?.suv,
            bookingId: response?.data?._id,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        let message = err?.response?.data?.message || err?.message;
        if (message) {
          swal("Error", message, "error");
        }
      });
  };
  const getServicesRates = async () => {
    setLoading(true);
    Get(BOOKING.getServicesRates, token, {
      duration: data?.duration,
      type: data?.type,
      initialMileage: data?.initialMileage.toFixed(2),
      time: moment(data?.time).format("HH:mm"),
    })
      .then((response) => {
        if (response?.status) {
          console.log(response?.data?.initialFares, "response");
          setServicesRates(response?.data?.initialFares);
          setIsMember(response?.data?.isMember);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        let message = err?.response?.data?.message || err?.message;
        if (
          message ===
          "You have an Unpaid booking. Kindly clear your previous dues first"
        ) {
          swal("Error", message, "error");
          navigate("/");
        }
        console.log(err, "Error fetching services rates");
      });
  };

  const calculateRushHourFee = () => {
    if (latestRates) {
      const serviceType =
        selectedTiming.split("-")[0] === "0"
          ? "Black"
          : selectedTiming.split("-")[0] === "1"
          ? "Ultra"
          : selectedTiming.split("-")[0] === "2"
          ? "Suv"
          : "Ultra Beyond";
      let service = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          parseInt(rate._id.passengerCapacity) ===
            parseInt(
              Object.keys(servicesRates[serviceType])[
                selectedTiming.split("-")[1]
              ]
            )
      );
      let fee = service?.rate * service?.rushHourMultiple * totalRushHours -
      totalRushHours * getHourlyRate()
      return (
        fee.toFixed(2)
      );
    }
  };
  // const calculateRushHourFee = () => {
  //   const serviceType =
  //     selectedTiming === 1 ? "Black" : selectedTiming === 2 ? "Ultra" : "Suv";
  //   let service = latestRates.find((rate) => rate._id === serviceType);
  //   return (
  //     service?.rate * service?.rushHourMultiple * totalRushHours -
  //     totalRushHours * getHourlyRate()
  //   );
  // };
  const getTotalRushHours = () => {
    const fromTime = moment(data?.time).format("HH:mm");
    const fromMoment = moment(fromTime, "HH:mm");
    const toTime = fromMoment.clone().add(data?.duration, "hours");
    Get(RUSH.getTotalRushHours, token, {
      from: fromMoment.format("HH:mm"), // Send formatted time
      to: toTime.format("HH:mm"), // Calculate and send the "to" time
    })
      .then((response) => {
        if (response?.status) {
          setTotalRushHours(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getToPay = () => {
    if (selectedTiming) {
      switch (selectedTiming.split("-")[0]) {
        case "0":
          return Object.values(servicesRates?.Black)[
            selectedTiming.split("-")[1]
          ];
        case "1":
          return Object.values(servicesRates?.Ultra)[
            selectedTiming.split("-")[1]
          ];
        case "2":
          return Object.values(servicesRates?.Suv)[
            selectedTiming.split("-")[1]
          ];
        case "3":
          return Object.values(servicesRates["Ultra Beyond"])[
            selectedTiming.split("-")[1]
          ];
      }
    }
  };
  return (
    <Row justify="center py-16" className="bg-white">
      {!loading ? (
        <Col md={22} xs={22}>
          <Row justify="center" gutter={[16, 16]}>
            <Col lg={8} xs={24}>
              {servicesRates && (
                <RideComponentRecent
                  pickupLocation={data?.pickupLocation}
                  dropoffLocation={data?.dropoffLocation}
                  selectedTiming={selectedTiming}
                  setSelectedTiming={setSelectedTiming}
                  servicesRates={servicesRates}
                />
              )}
            </Col>
            <Col lg={12} xs={24}>
              {/* <h4 className="font-tavi text-3xl text-black mb-4">
                  All classes offer the following benefits:
                </h4>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> Free cancellation
                  up to 1 hour before pickup
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> 15 minutes of
                  complimentary wait time
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> Meet & Greet
                  service
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> A complimentary
                  bottle of water
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> Free in-vehicle
                  WiFi
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> Tissues and hand
                  sanitizer
                </p>
                <p className="flex items-center gap-2 font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  <FaCheckCircle className="text-[green]" /> Chargers for both
                  Android and iPhone devices
                </p> */}
              <div className="border border-gray-300 py-8 px-4 flex flex-col justify-start items-start sm:pb-20 booking-details-bx">
                <div className="border border-gray-300 py-4 px-4">
                  <h4 className="font-tavi text-[30px] text-black mt-2">
                    {data?.type === "PtoP"
                      ? "Distance Service in Manhattan"
                      : "Hourly Service in Manhattan"}
                  </h4>
                  <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black">
                      Vehicle Type:
                    </span>{" "}
                    {/* Black Luxury */}
                    {selectedTiming.split("-")[0] === "0"
                      ? "Black Luxury"
                      : selectedTiming.split("-")[0] === "1"
                      ? "Ultra Luxury"
                      : selectedTiming.split("-")[0] === "2"
                      ? "SUV Luxury"
                      : "-"}
                  </p>
                  {data?.duration ? (
                    <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                      <span className="text-[#000] font-black">
                        {" "}
                        Booking Duration:
                      </span>{" "}
                      {data?.duration} hours
                    </p>
                  ) : (
                    <></>
                  )}
                  <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                    {data?.initialMileage ? (
                      <span className="text-[#000] font-black"> Mileage:</span>
                    ) : (
                      <></>
                    )}{" "}
                    {data?.initialMileage
                      ? data?.initialMileage.toFixed(2) + " miles"
                      : null}
                  </p>

                  <Divider className="my-2" />

                  <h4 className="font-tavi text-[20px] text-black mt-2">
                    Pricing Breakdown:
                  </h4>
                  {!isMember &&
                    (data?.duration ? (
                      <>
                        <span className="text-[#000] font-semibold pt-2">
                          Hourly Rate: ${getHourlyRate()} per hour
                        </span>
                        <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666] font-bold transition-colors">
                          Total for {data?.duration} hours: {data?.duration}{" "}
                          hours × ${getHourlyRate()}/hour = $
                          {getHourlyRate() * data?.duration}
                        </p>
                      </>
                    ) : null)}

                  {data?.initialMileage ? (
                    <>
                      <span className="text-[#000] font-semibold pt-2">
                        Mileage Fee:
                      </span>
                      <p className="font-euclid text-sm  lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                        {selectedTiming === 1
                          ? "Black"
                          : selectedTiming === 2
                          ? "Ultra"
                          : "SUV"}{" "}
                        Luxury: ${getPerMileRate()} per mile
                      </p>
                      <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                        Total for {data?.initialMileage.toFixed(2)} miles:{" "}
                        {data?.initialMileage.toFixed(2)} miles × $
                        {getPerMileRate()}/mile = $
                        {(
                          data?.initialMileage.toFixed(2) * getPerMileRate()
                        ).toFixed(2)}
                      </p>
                    </>
                  ) : (
                    <></>
                  )}
                  {totalRushHours && data?.duration ? (
                    <p className="text-[#000] font-semibold pt-2">
                      Rush Hour Fee : ${(calculateRushHourFee() / totalRushHours).toFixed(2)}{" "}
                      per hour <br />
                      <span className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666] font-bold transition-colors">
                        {" "}
                        Total for {totalRushHours.toFixed(2)} hours : {totalRushHours.toFixed(2)}{" "}
                        hours x ${(calculateRushHourFee() / totalRushHours).toFixed(2)} = $
                        {calculateRushHourFee()}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                  <Divider className="my-2" />
                  <span className="text-[#000] font-bold pt-2 lg:text-base">
                    {/* To Pay: ${getTotalFare()} */}
                    {/* To Pay: $
                    {(selectedTiming === 1
                      ? servicesRates?.black
                      : selectedTiming === 2
                      ? servicesRates?.ultra
                      : servicesRates?.suv
                    ).toFixed(2)} */}
                    ${getToPay().toFixed(2)}
                  </span>
                </div>

                <h4 className="font-tavi text-[25px] text-black mt-4">
                  Please add notes here:
                </h4>
                <TextArea
                  rows={4}
                  onChange={(e) => {
                    setNotes(e.target.value);
                  }}
                  // placeholder="Please include any special requests, such as the number of bags or child seats. Avoid sharing any confidential information."
                  placeholder="Your destination details among any special request."
                />

                <h4 className="font-tavi text-[20px] text-black  mt-4">
                  Please keep in mind:
                </h4>
                <p className="font-euclid text-xs max-sm:text-xs text-[#666]  font-bold transition-colors py-2">
                  {/* For safety reasons, please adhere to the guest and luggage
                  capacity limits. If you're uncertain, it's best to choose a
                  larger class, as chauffeurs may refuse service if these limits
                  are exceeded. */}
                  {data?.type === "PtoP"
                    ? "If your service exceeds more than the initially estimated miles than you will be charged extra for the additional miles at the end of the reservation with the extra mileage rate."
                    : "If your service exceeds more than the initial selected hours than you will be charged extra for the additional hours at the end of the reservation with the extra hourly rate."}
                </p>
                <Checkbox onChange={onChange} className="text-black">
                  I accept the Terms & Conditions.
                </Checkbox>
                {selectedTiming !== null && (
                  <button
                    disabled={!checked}
                    onClick={handleProceed}
                    className={`uppercase py-4 w-full rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6 
         ${
           checked
             ? "bg-button text-white cursor-pointer"
             : "bg-gray-300 text-gray-500 cursor-not-allowed"
         }`}
                  >
                    Let's proceed
                  </button>
                )}
              </div>
            </Col>

            <Modal
              title="Location Details"
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              footer={[
                <Button key="close" onClick={() => setModalVisible(false)}>
                  Close
                </Button>,
              ]}
            >
              <p>{hoveredLocation}</p>
            </Modal>
          </Row>
        </Col>
      ) : (
        <Col style={{ margin: "200px 0px" }}>
          <Spin />
        </Col>
      )}
    </Row>
  );
};

export default RecentPage;
